import * as styles from "./Kbd.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useButtonContext } from "@frontend/components/atoms/Button/Button.context";

import type { KbdProps } from "./Kbd.types";

export function Kbd({
  className,
  variant,
  tone,
  ...props
}: KbdProps): JSX.Element {
  const buttonContext = useButtonContext();

  const resolvedVariant = variant ?? buttonContext?.variant;

  return (
    <kbd
      data-slot="kbd"
      data-tone={tone}
      className={clsx(
        styles.kbd({ variant: resolvedVariant, tone }),
        className,
      )}
      {...props}
    />
  );
}
